import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
export default {
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`payrollfrm1721/${obj.payrollkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'tahunpajak','crewnik', 'crewname', 'jabatan', 'departemen',  'projectid', 'projectname'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/payrollfrm1721/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Payroll_List.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tahunpajak','crewnik', 'crewname', 'jabatan', 'departemen',  'projectid', 'projectname'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/payrollfrm1721${str}`;
                const { data } = await axios.get(url);
                // const { meta, list } = data;
                // obj.total = meta.total;
                resolve(data.list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },     
    process(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/payrollfrm1721/process', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    cancel(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/payrollfrm1721/cancel', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.payrollkey);
                url = `/payrollfrm1721/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    printmulti(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?tahunpajak=' + encodeURIComponent(obj.tahunpajak);
                if (obj.arrCrewkey) {
                    str += '&arrCrewkey=' + encodeURIComponent(JSON.stringify(obj.arrCrewkey));
                } else {
                    str += '&projectid=' + encodeURIComponent(obj.projectid);
                }
                url = `/payrollfrm1721/printmulti`;
                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
};